import moment from 'moment';
export const dateMixin = {
  data() {
    return {
      defaultTimeOfRange: 2*60,
      // defaultTimeOfRange: 2.5*60,
      emptyDate: '0000-00-00 00:00:00',
      // defaultTimeOfRange: 30,
    }; // return DATA
  }, // DATA
  filters: {
    minToHour: function (val) {
      let hour = ('0'+ parseInt(val/60)).substr(-2);
      let min = ('0'+ parseInt(val%60)).substr(-2);
      return hour +':'+ min;
    },
  }, // FILTERS
  methods: {

// WORKING WITH DATES
  getNameOfDate(date, Hide = {}) {
    if (date == this.getActualDateToDB()) return 'Hoy';
    if (date == this.getActualDateToDB({day: +1})) return 'Mañana';
    let daysOfWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado',];
    let monthsNames = [null, 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',];
    let dayName = daysOfWeek[+this.getDayOfWeek(date)];
    let dayNum = this.getDayOfMonth(date);
    let monthName = monthsNames[+this.getMonth(date)];
    let year = this.getYear(date);
    let msg = `${dayName} ${dayNum} de ${monthName}`;
    if (Hide.year != false) msg += ` de ${year}`
    return msg;
  },
  getDayOfMonth(date) {
    return this.getMomentByDate(date).format('DD');
  },
  getMonth(date) {
    return this.getMomentByDate(date).format('MM');
  },
  getYear(date) {
    return this.getMomentByDate(date).format('YYYY');
  },
  getDayOfWeek(date) {
    return this.getMomentByDate(date).day();
  },

// OTRAS COSAS

    // getNameOfDate
    // minToHour
    // showRange
    showRange(time, timeOfRange = null) {
      timeOfRange = timeOfRange == null ? this.defaultTimeOfRange : timeOfRange;
      return `Entre ${this.minToHour(time)} y ${this.minToHour((time)+timeOfRange)}`
    },
    minToHour(val) {
      let hour = this.pad(parseInt(val/60), 2);
      let min = this.pad(parseInt(val%60), 2);
      return hour +':'+ min;
    },
    dateIsNewer(date1, date2) {
      let d1 = {
        year: date1.substring(0,4),
        month: date1.substring(5,7),
        day: date1.substring(8,10),
      };
      let d2 = {
        year: date2.substring(0,4),
        month: date2.substring(5,7),
        day: date2.substring(8,10),
      };
      if (d1.year > d2.year) return true;
      if (d1.month > d2.month) return true;
      if (d1.day > d2.day) return true;
      return false;
    },

// DATE COSAS

    getMoment(Diference = {}) {
      Diference.day = Diference.day || 0;
      Diference.month = Diference.month || 0;
      Diference.year = Diference.year || 0;
      let m = moment();
      m.add(Diference.day, 'days');
      m.add(Diference.month, 'months');
      m.add(Diference.year, 'years');
      return m;
      // return m.format('DD/MM/YYYY');
    },
    getMomentByDate(date) {
      return moment(date);
    },
    // getActualDatetime

    getActualDayOfMonth(Diference = {}) {
      return this.getMoment(Diference).format('DD');
    },
    getActualMonth(Diference = {}) {
      return this.getMoment(Diference).format('MM');
    },

    // TO DB
    getActualDateToDB(Diference = {}) {
      return this.getMoment(Diference).format('YYYY-MM-DD');
    },
    getActualDatetimeToDB(Diference = {}) {
      return this.getMoment(Diference).format('YYYY-MM-DD HH:mm:ss');
    },
    getActualDayOfWeek(Diference = {}) {
      return this.getMoment(Diference).day();
    },
    getActualMinutesOfDay() {
      let hour = this.getMoment().format('HH');
      let min = this.getMoment().format('mm');
      return +hour * 60 + +min;
    },


    // FROM DB
    getDayOfDB(date) {
      return date.substring(8,10);
    },
    getMonthOfDB(date) {
      return date.substring(5,7);
    },
    getDateOfDB(date, onlyNumber = false) {
      if (!onlyNumber) {
        if (date == this.getActualDateToDB()) return 'Hoy';
        // if (date == this.getActualDateToDB({day: +2})) return 'Pasado mañana';
        if (date == this.getActualDateToDB({day: +1})) return 'Mañana';
        if (date == this.getActualDateToDB({day: -1})) return 'Ayer';
        if (date == this.getActualDateToDB({day: -2})) return 'Anteayer';
      }
      if (date == '0000-00-00') return '-';
      let month   = date.substring(5,7).padStart(2, '0');
      let day = date.substring(8,10).padStart(2, '0');
      let year  = date.substring(2,4);
      return day +'/'+ month +'/'+ year;
    },
    getTimeOfDB(date) {
      return date.substring(11, 16);
    },
  }, // METHODS
} // export
